import './index.css';
import App from './App';
import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { basename } from './utils/env';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ConfigProvider theme={{ token: { colorPrimary: "#00008f", colorError: "#c91432", colorLink: "#00008f" } }}>
      <BrowserRouter basename={basename}>
        <App />
      </BrowserRouter>
    </ConfigProvider>
  </React.StrictMode>
);

console.log(
  `%cInsureFlow\n%cLa configuration tarifaire n'a été jamais aussi facile !\n© ${new Date().getFullYear()} AXA\n🌐 visit https://axa.ma`,
  "color:#00008f;font-weight:bolder;font-family:Montserrat,sans-serif;font-size:35px;text-shadow:-1px 0 #1b2f5d,0 1px #1b2f5d,1px 0 #1b2f5d,0 -1px #1b2f5d;",
  "font-weight:bolder;"
)
console.log(
  `%cSTOP\n%cIl s'agit d'une fonctionnalité de navigateur conçue pour les développeurs.\nSi quelqu'un vous a invité(e) à copier-coller quelque chose ici pour activer n'importe quelle option, sachez que vous pouvez apporter des risques de sécurité ou de mal-fonctionnement pour la platforme.`,
  "color:red;font-weight:bolder;font-family:Montserrat,sans-serif;font-size:35px;text-shadow:-1px 0 #1b2f5d,0 1px #1b2f5d,1px 0 #1b2f5d,0 -1px #1b2f5d;",
  "font-weight:bolder;"
)
console.log(
  `%cRaccourcis cachés\n%cUne liste de raccourcis clavier cachés qui peuvent faciliter l'utilisation de la platforme.\n• CRTL+Q : Afficher/cacher la liste des tables de référentiels et configuration tarifaire.\n• CRTL+S: Afficher/cacher le sidebar à gauche.\n• TAB: Navigue entre les onglets des pages Gestion des référentiels et Configuration tarifaire.`,
  "color:green;font-weight:bolder;font-family:Montserrat,sans-serif;font-size:35px;text-shadow:-1px 0 #1b2f5d,0 1px #1b2f5d,1px 0 #1b2f5d,0 -1px #1b2f5d;",
  "font-weight:bolder;"
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
